var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "logout"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13950",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72374",
    d: "M107.5 19.837a2.338 2.338 0 0 1 2.338-2.337h6.783a2.338 2.338 0 0 1 2.338 2.337v14.117a2.338 2.338 0 0 1-2.338 2.338h-6.783a2.338 2.338 0 0 1-2.338-2.338v-3.391a1.146 1.146 0 1 1 2.292 0v3.392a.046.046 0 0 0 .046.046h6.783a.046.046 0 0 0 .046-.046V19.837a.046.046 0 0 0-.046-.046h-6.783a.046.046 0 0 0-.046.046v3.392a1.146 1.146 0 1 1-2.292 0z",
    transform: "translate(-97.646 -15.896)",
    style: {
      fill: "#9da8b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72375",
    d: "M25.673 61.836a1.146 1.146 0 0 1 0 1.62l-2.261 2.261h6.95a1.146 1.146 0 1 1 0 2.292h-6.95l2.261 2.261a1.146 1.146 0 1 1-1.62 1.62L19.9 67.738l-.033-.034a1.146 1.146 0 0 1 0-1.683l.033-.034 4.152-4.152a1.146 1.146 0 0 1 1.621.001z",
    transform: "translate(-17.712 -55.862)",
    style: {
      fill: "#9da8b7"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.dcb347b613ffb0cf1ab5a0bfd2f425a7.svg";
export { ForwardRef as ReactComponent };